export function replaceAttrInPopupHtml(html = '') {
    return html
        .replace(/send-text/gi, 'data-alan-btn-send-text')
        .replace(/call-project-api/gi, 'data-alan-btn-call-project-api')
        .replace(/project-api-param/gi, 'data-alan-btn-project-api-param');
}